import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export const throwIfNullish =
  <T>(errorFactory: () => unknown) =>
  (obs: Observable<T | null | undefined>): Observable<T> =>
    obs.pipe(
      map(value => {
        if (value === null || value === undefined) {
          throw errorFactory();
        } else {
          return value;
        }
      })
    );
